module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/frame/frame.component.scss
// module id = ./src/app/layouts/frame/frame.component.scss
// module chunks = main